module.exports = __webpack_public_path__ + "img/diamond_elite.d18f08f3.png";